module.exports = "successor"